import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.acceptContractCheckbox = this.element.querySelector('input[name="consents[e_contract]"]');
        this.modal = document.getElementById('e-contract');

        if (this.acceptContractCheckbox && this.modal) {
            this.modalAccept = this.modal.querySelector('.modal-accept');
            this.modalReplacement = this.modal.querySelector('.replace-content');
            this.modalLoader = this.modal.querySelector('.loader');
            this.acceptContractCheckbox.addEventListener('click', (event) => this.showEContractAcceptModal(event));

            this.modalAccept.addEventListener('click', () => {
                if (!this.acceptContractCheckbox.checked) {
                    this.acceptContractCheckbox.checked = true;
                    this.modalController = Stimulus.getControllerForElementAndIdentifier(this.modal, 'modal');
                    this.modalController.hideModal();
                }
            });
        }
    }

    async showEContractAcceptModal(event) {
        if (this.acceptContractCheckbox.checked) {
            event.preventDefault();
            this.modalController = Stimulus.getControllerForElementAndIdentifier(this.modal, 'modal');
            this.modalLoader.classList.remove('d-none');
            this.modalReplacement.innerHTML = '';
            this.modalController.showModal();
            this.currentLanguageCode = document.documentElement.lang.split('-')[0];

            const queryString = new URLSearchParams(new FormData(this.element)).toString();

            let response;
            const url = `/wp-json/api/debit-pdf-template?rest_language=${this.currentLanguageCode}&${queryString}`;

            try {
                response = await axios.get(url);
                response = response.data.data;
            } catch (error) {
                response = error.response.data.data;
            }

            this.modalLoader.classList.add('d-none');

            if (response.contract) {
                this.modalReplacement.innerHTML = '<iframe></iframe>';
                // this.modalReplacement.innerHTML = '<iframe src="' + 'data:text/html,' + encodeURIComponent(response.contract) + '"></iframe>';

                // setTimeout needed for Firefox to display content
                setTimeout(() => {
                    this.modalReplacement.firstElementChild.contentWindow.document.body.innerHTML = response.contract;
                    this.modalReplacement.firstElementChild.height = `${this.modalReplacement.firstElementChild.contentWindow.document.body.scrollHeight}px`;
                }, 0);

                // this.modalReplacement.innerHTML = response.contract;
            } else {
                const messageNode = document.createElement('span');
                messageNode.classList.add('general-error');
                messageNode.innerHTML = document.querySelector('meta[name="global_axios_validator_error"]').content;
                this.modalReplacement.innerHTML = messageNode;
            }
        } else {
            this.modalReplacement.innerHTML = '';
        }
    }

    async change(event) {
        const date = event.target.value;
        const lang = document.documentElement.lang.split('-')[0];
        const promoCodeHolder = document.querySelector('#promo-code-holder');
        let plan = this.element.querySelector('input[name="debit_id"]');
        let price = 0;

        if (plan && plan.value) {
            plan = plan.value;

            const priceElement = document.getElementById('start_price');
            let response;

            try {
                response = await axios.get(`/wp-json/api/debit-checkout-price` + `?rest_language=${lang}&date=${date}&plan=${plan}`);
                response = response.data.data;
            } catch (error) {
                response = error.response.data.data;
            }

            price = response.price;

            if (promoCodeHolder && promoCodeHolder.dataset.discount) {
                price = Number(response.price.replace(',', '')) - Number(response.price.replace(',', '') / 100 * Number(promoCodeHolder.dataset.discount));
                price = (price / 100).toFixed(2);
            }

            priceElement.innerHTML = price;
        }
    }
}
